// extracted by mini-css-extract-plugin
module.exports = {"SortModalContainer":"SortModal_SortModalContainer__3ZNHE","CheckboxStyle":"SortModal_CheckboxStyle__2UW84","ant-checkbox-inner":"SortModal_ant-checkbox-inner__yznb_"};